<template>
    <div class="vue-css-scale" :class="[position,className]">
        <img :src="url" :style="{imgClass: '100%'}">
    </div>
</template>
<script type="text/javascript">

    export default {
        props: {
            position: {
                type: String,
                default: ''
            },
            className: {
                type: String
            },
            url: {
                type: String
            },
            imgClass: {
                type: String
            }
        },
        methods: {},
        mounted() {

        }
    }

</script>
<style rel="stylesheet/scss" lang="scss" type="text/scss">
    .vue-css-scale {
        position: relative;
        width: 100%;
        height: 100%;
        line-height: inherit;
        overflow: hidden;
        img {
            display: inline-block;
            vertical-align: middle;
            transition: transform 1s, -webkit-transform 1s;
        }
        &:hover {
            img {
                transform: scale(1.15);
            }
        }
        &.x:hover {
            img {
                transform: scaleX(1.15);
            }
        }
        &.y:hover {
            img {
                transform: scaleY(1.15);
            }
        }
    }
</style>
